import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import AppButton from "../forms/button";
import { getActionHref } from "../../utils/contactActionHandler";
import { isMobileOrTablet } from "../../utils/deviceDetect";
import { useEffect, useState } from "react";
import { colors } from "../../theme/color";

const CommonErrorPage = ({
  title,
  description,
  image,
  actionLabel,
  onActionClick,
  content,
  content1,
  code,
  phoneNubmer,
  mailId,
  goToLogin,
}) => {
  const [isMobile, setIsMobile] = useState(isMobileOrTablet());

  useEffect(() => {
    const handleResize = () => {
      const mobileCheck = isMobileOrTablet();
      setIsMobile(mobileCheck);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const phoneHref = getActionHref({
    actionType: "call",
    value: phoneNubmer,
    isMobile: isMobile,
  });

  const mailHref = getActionHref({
    actionType: "mail",
    value: mailId,
    isMobile: isMobile,
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 2, md: 4 },
        py: { xs: 1, md: 2 },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" },
          alignItems: "center",
          gap: { xs: 4, sm: 2, md: 10 },
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "28px", sm: "42px", md: "51px" },
              color: colors.textColor,

              whiteSpace: {
                xs: "normal", // always wrap on mobile
                md: code === 30001 ? "normal" : "nowrap",
              },

              overflowWrap: "break-word",
              wordBreak: "break-word",
            }}
            className="font-semibold"
            gutterBottom
          >
            {title}
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "20px", md: "25px" },
              fontWeight: code === 30001 ? 400 : 600,
            }}
            className="text-lightTextColor mb-2"
          >
            {description}
          </Typography>

          {content1 && (
            <Typography
              sx={{ fontSize: { xs: "18px", sm: "20px", md: "25px" } }}
              className="text-lightTextColor  font-semibold mt-4"
            >
              {content1}
            </Typography>
          )}
          <Box
            sx={{
              display: { xs: "flex", sm: "block" },
              justifyContent: { xs: "center", sm: "flex-start" },
              alignItems: { xs: "center", sm: "stretch" },
              mt: 2,
            }}
          >
            {code === 30001 ? (
              <AppButton
                variant="contained"
                icon="/image/refresh_icon.svg"
                text={actionLabel}
                onClick={onActionClick}
                className="!mr-0 px-5 py-4 rounded-lg mt-8 text-base font-semibold"
              />
            ) : code === 20004 || code === 20005 || code === 20006 ? (
              <AppButton
                variant="contained"
                className="!mr-0 mt-8 text-brandDark rounded-lg py-4 px-5 text-base font-semibold bg-lightButtonColor"
                text={actionLabel}
                onClick={goToLogin}
              />
            ) : code === 40001 ? (
              <AppButton
                variant="outlined"
                className="!mr-0 mt-8 text-brandDark rounded-lg py-4 px-5 text-base font-semibold border-buttonBorder"
                text={actionLabel}
                onClick={onActionClick}
              ></AppButton>
            ) : (
              <AppButton
                variant="outlined"
                className="!mr-0 mt-8 text-brandDark rounded-lg py-4 px-5 text-base font-semibold border-buttonBorder"
                text={actionLabel}
                onClick={goToLogin}
              ></AppButton>
            )}
          </Box>
          {code && code !== 40001 && (
            <>
              <Typography
                sx={{ fontSize: { xs: "18px", sm: "20px", md: "25px" } }}
                className="text-lightTextColor  font-normal"
                mt={6}
              >
                {content}
              </Typography>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                mt={3}
                alignItems="center"
              >
                <AppButton
                  variant="outlined"
                  href={isMobile ? phoneHref : undefined}
                  icon="/image/error_page_phone_icon.svg"
                  className="text-sm text-brandDark py-1 px-4 border-buttonBorder rounded-sm"
                  text={phoneNubmer}
                ></AppButton>
                <AppButton
                  variant="outlined"
                  href={mailHref}
                  icon="/image/error_page_mail_icon.svg"
                  className="text-sm text-brandDark py-1 px-4 border-buttonBorder rounded-sm"
                  text={mailId}
                ></AppButton>
              </Stack>
            </>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            transform: { xs: "none", md: "translateY(-50px)" },
          }}
        >
          {image && (
            <Box
              component="img"
              src={image}
              alt="error"
              sx={{ width: "100%", height: "auto" }}
              className="mb-4"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default CommonErrorPage;

CommonErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  actionLabel: PropTypes.string,
  content: PropTypes.string,
  code: PropTypes.number,
  onActionClick: PropTypes.func,
  content1: PropTypes.string,
  phoneNubmer: PropTypes.string,
  mailId: PropTypes.string,
  goToLogin: PropTypes.func,
};
